import { render, staticRenderFns } from "./AdminSubLayout.vue?vue&type=template&id=6f5f8df2&"
import script from "./AdminSubLayout.vue?vue&type=script&lang=js&"
export * from "./AdminSubLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubLayout.vue?vue&type=style&index=0&id=6f5f8df2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports